import React from "react";
import {Card} from "react-bootstrap";
import {FaChartColumn} from "react-icons/fa6";
import {CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

const formatMoney = (value) => new Intl.NumberFormat("en-IN", {style: "currency", currency: "INR", maximumFractionDigits: 0}).format(Number(value) || 0);

const SalesGraph = ({data}) => {
    const transformedData = Object.entries(data?.daily_revenue_last_7_days || {}).map(([date, revenue]) => ({
        date,
        revenue: Number(revenue) || 0,
    }));

    return (
        <Card className="dashboard-card mb-4">
            <Card.Body>
                <div className="d-flex justify-content-between align-items-start gap-3">
                    <div>
                        <h2 className="dashboard-card-title">Sales trend</h2>
                        <p className="dashboard-card-subtitle">Daily revenue over the last 7 days</p>
                    </div>
                    <span className="dashboard-card-subtitle">Last 7 days</span>
                </div>
                {transformedData.some((point) => point.revenue > 0) ? (
                    <div className="sales-chart-wrap">
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart data={transformedData} margin={{top: 10, right: 14, left: 3, bottom: 0}}>
                                <CartesianGrid stroke="#edf0f5" strokeDasharray="4 4" vertical={false} />
                                <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{fill: "#8995a6", fontSize: 10}} />
                                <YAxis axisLine={false} tickLine={false} tick={{fill: "#8995a6", fontSize: 10}} tickFormatter={(value) => `₹${value}`} width={58} />
                                <Tooltip formatter={(value) => [formatMoney(value), "Sales"]} contentStyle={{borderRadius: 10, borderColor: "#e7ebf1", fontSize: 12}} />
                                <Line type="monotone" dataKey="revenue" stroke="#ff7538" strokeWidth={3} dot={{r: 3, fill: "#ff7538", strokeWidth: 0}} activeDot={{r: 5}} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                ) : (
                    <div className="chart-empty">
                        <span className="chart-empty-icon"><FaChartColumn /></span>
                        <strong>No sales data for this period</strong>
                        <span>Paid orders will appear here as sales are recorded.</span>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default SalesGraph;
